import React from "react";
import NotificationMenuItem from "./NotificationMenuItem.js";

const NotificationMessage = ({
  notification,
  handleChangeCallback,
  handleClickCallback,
}) => {
  const date = new Date(parseInt(notification.creationDate) * 1000);
  const title = `${notification.params.authorNom} ${notification.params.authorPrenom}`;
  return (
    <NotificationMenuItem
      notification={notification}
      date={date}
      title={title}
      message="vient de vous envoyer un message."
      handleChangeCallback={handleChangeCallback}
      handleClickCallback={handleClickCallback}
    />
  );
};

export default NotificationMessage;
